import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { getGridLabelKey, ICustomField, RydeUiUnit } from "@ryde/shared";

export const useDynamicGridTranslate = () => {
  const { t } = useTranslation();

  const getGridLabelTranslated = useCallback(
    (entity: RydeUiUnit, name: string, fallbackText?: string | null) => {
      if (!name || !entity || entity === "unknown") {
        return fallbackText || "";
      }

      const gridLabelKey = getGridLabelKey(entity, name);
      return t(gridLabelKey);
    },
    [t],
  );

  const getGridLabelTranslationKey = useCallback(
    (entity: RydeUiUnit, name: string, fallbackText?: string | null) => {
      if (!name || !entity || entity === "unknown") {
        return fallbackText || "";
      }

      const gridLabelKey = getGridLabelKey(entity, name);
      return gridLabelKey;
    },
    [],
  );

  const getGridLabelComputed = useCallback(
    (entity: RydeUiUnit, control: ICustomField) => {
      const gridFallbackLabel =
        control.gridLabel ||
        control.formLabel ||
        control.formAttributes?.dropItemsSource ||
        control.name;
      return getGridLabelTranslated(entity, control.name, gridFallbackLabel);
    },
    [getGridLabelTranslated],
  );

  const getGridLabelTranslationKeyComputed = useCallback(
    (entity: RydeUiUnit, control: ICustomField) => {
      const gridFallbackLabel =
        control.gridLabel ||
        control.formLabel ||
        control.formAttributes?.dropItemsSource ||
        control.name;
      return getGridLabelTranslationKey(
        entity,
        control.name,
        gridFallbackLabel,
      );
    },
    [getGridLabelTranslationKey],
  );

  return {
    getGridLabelTranslated,
    getGridLabelComputed,
    getGridLabelTranslationKeyComputed,
  };
};
